var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cmp-title g-title",class:{'white': _vm.isWhite}},[_c('i',{staticClass:"line line-l"}),_c('i',{staticClass:"icon icon-l"}),_c('p',{staticClass:"name-box"},_vm._l((_vm.title),function(i){return _c('span',{staticClass:"name"},[_vm._v(_vm._s(i))])}),0),_c('i',{staticClass:"icon icon-r"}),_c('i',{staticClass:"line line-r"})])
}
var staticRenderFns = []

export { render, staticRenderFns }